import { render, staticRenderFns } from "./ModuleMenuPanel.vue?vue&type=template&id=84d63fe4"
import script from "./ModuleMenuPanel.vue?vue&type=script&lang=js"
export * from "./ModuleMenuPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports